<script>
import { h, provide, ref } from 'vue'
import cardPosterTemplate from './components/card-poster-template.vue'
import templateGroup from '../components/template-group.vue'
import { ElTabs, ElTabPane } from 'element-plus'
import type from '@/common/utils/type'
export default {
  setup () {
    const cardPosterTemplateCom = ref(null)
    const tabs = {
      activeName: 'cardPosterTemplate',
      tabs: [
        { label: '名片模板', name: 'cardPosterTemplate', component: cardPosterTemplate, ref: cardPosterTemplateCom },
        { label: '模板类型', name: 'templateGroup', component: templateGroup }
      ]
    }
    provide('reloadTemplate', () => cardPosterTemplateCom.value.searchData())

    return {
      tabs
    }
  },
  render () {
    return h(
      ElTabs, {
        modelValue: this.tabs.activeName
      }, () => this.tabs.tabs.map(item => {
        return h(ElTabPane, {
          name: item.name,
          label: item.label
        }, () => [
          h(item.component, {
            ref: item.ref || '',
            type: type().templateGroupType.card
          })
        ])
      })
    )
  }
}
</script>
<style lang="scss" scoped>
</style>
